import { render, staticRenderFns } from "./imageUploader.vue?vue&type=template&id=3afb29bd&scoped=true&"
import script from "./imageUploader.vue?vue&type=script&lang=js&"
export * from "./imageUploader.vue?vue&type=script&lang=js&"
import style0 from "./imageUploader.vue?vue&type=style&index=0&id=3afb29bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afb29bd",
  null
  
)

export default component.exports